/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCampaignFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCampaign, serializeCampaignInput, type Campaign, type CampaignInput, type ErrorResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { ActiveRequestBuilderRequestsMetadata, type ActiveRequestBuilder } from './active/index.js';
// @ts-ignore
import { CodesRequestBuilderNavigationMetadata, CodesRequestBuilderRequestsMetadata, type CodesRequestBuilder } from './codes/index.js';
// @ts-ignore
import { PromotionRedemptionsRequestBuilderRequestsMetadata, type PromotionRedemptionsRequestBuilder } from './promotionRedemptions/index.js';
// @ts-ignore
import { RedemptionsRequestBuilderRequestsMetadata, type RedemptionsRequestBuilder } from './redemptions/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/campaigns/{campaignId}
 */
export interface WithCampaignItemRequestBuilder extends BaseRequestBuilder<WithCampaignItemRequestBuilder> {
    /**
     * The active property
     */
    get active(): ActiveRequestBuilder;
    /**
     * The codes property
     */
    get codes(): CodesRequestBuilder;
    /**
     * The promotionRedemptions property
     */
    get promotionRedemptions(): PromotionRedemptionsRequestBuilder;
    /**
     * The redemptions property
     */
    get redemptions(): RedemptionsRequestBuilder;
    /**
     * Deletes the campaign and every discount code it has. Refused once any order has redeemed the campaign — the order ledger refers to it — in which case deactivate it instead. A cart still holding one of its codes sees the code as unknown on its next change.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * One campaign with its promotions and counters.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Campaign>}
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Campaign | undefined>;
    /**
     * Replaces the campaign's audience, trigger, cap and promotions. Pass each existing promotion's id to keep its identity (carts and orders reference it); a promotion without an id is new. The redemption count and the active flag are untouched. A promotion left out is deleted, which is refused once any order has redeemed it: deactivate it instead. Carts re-evaluate on their next change; checkout re-checks regardless.
     * @param body A campaign as the Web Admin builder sends it: the audience, the trigger, the cap and theembedded promotions. Counters (redemptionCount) are never part of the input — they areserver-managed (D11).
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Campaign>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: CampaignInput, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Campaign | undefined>;
    /**
     * Deletes the campaign and every discount code it has. Refused once any order has redeemed the campaign — the order ledger refers to it — in which case deactivate it instead. A cart still holding one of its codes sees the code as unknown on its next change.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * One campaign with its promotions and counters.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Replaces the campaign's audience, trigger, cap and promotions. Pass each existing promotion's id to keep its identity (carts and orders reference it); a promotion without an id is new. The redemption count and the active flag are untouched. A promotion left out is deleted, which is refused once any order has redeemed it: deactivate it instead. Carts re-evaluate on their next change; checkout re-checks regardless.
     * @param body A campaign as the Web Admin builder sends it: the audience, the trigger, the cap and theembedded promotions. Counters (redemptionCount) are never part of the input — they areserver-managed (D11).
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: CampaignInput, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithCampaignItemRequestBuilderUriTemplate = "{+baseurl}/api/campaigns/{campaignId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCampaignItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCampaignItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    active: {
        requestsMetadata: ActiveRequestBuilderRequestsMetadata,
    },
    codes: {
        requestsMetadata: CodesRequestBuilderRequestsMetadata,
        navigationMetadata: CodesRequestBuilderNavigationMetadata,
    },
    promotionRedemptions: {
        requestsMetadata: PromotionRedemptionsRequestBuilderRequestsMetadata,
    },
    redemptions: {
        requestsMetadata: RedemptionsRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCampaignItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithCampaignItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: WithCampaignItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCampaignFromDiscriminatorValue,
    },
    put: {
        uriTemplate: WithCampaignItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCampaignFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCampaignInput,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
